'use strict'

# trackEvent:
module.exports = (eventName, payload = {}) ->
  defaults =
    b: Cookie.get('b')
    pageId: location.pathname
  payload = Object.assign {}, payload, defaults

  OptimizeSuite?.TrackingHub?.add("#{eventName}", payload)
  return



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/trackEvent.coffee